import { withI18n } from 'react-i18next';
import TrackingHeader from './TrackingHeader';

export const pureComponent = TrackingHeader;
export default withI18n()(TrackingHeader);
